var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "17",
        height: "17",
        viewBox: "0 0 17 17",
        fill: "none",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_704_585)" } }, [
        _c("path", {
          attrs: {
            d: "M14.7501 7.02384C14.7501 11.9405 8.42861 16.1548 8.42861 16.1548C8.42861 16.1548 2.10715 11.9405 2.10715 7.02384C2.10715 5.34729 2.77316 3.7394 3.95867 2.5539C5.14417 1.36839 6.75206 0.702385 8.42861 0.702385C10.1052 0.702385 11.7131 1.36839 12.8986 2.5539C14.0841 3.7394 14.7501 5.34729 14.7501 7.02384Z",
            fill: "black",
            stroke: "black",
            "stroke-width": "1.40477",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M8.42861 9.131C9.59236 9.131 10.5358 8.18759 10.5358 7.02384C10.5358 5.8601 9.59236 4.91669 8.42861 4.91669C7.26487 4.91669 6.32146 5.8601 6.32146 7.02384C6.32146 8.18759 7.26487 9.131 8.42861 9.131Z",
            fill: "white",
            stroke: "white",
            "stroke-width": "1.40477",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_704_585" } }, [
          _c("rect", {
            attrs: { width: "16.8572", height: "16.8572", fill: "white" },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }